import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InsuranceCategory } from './types'

interface InsuranceCategoryState {
  selectedCategory: InsuranceCategory | null
}

const SLICE_NAME = 'insuranceCategory'

const initialState: InsuranceCategoryState = {
  selectedCategory: null
}

const insuranceCategorySlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setSelectedCategory: (state, action: PayloadAction<InsuranceCategory>) => ({
      ...state,
      selectedCategory: action.payload
    }),
    clearSelectedCategory: () => initialState
  },
  selectors: {
    selectSelectedCategory: (state) => state.selectedCategory
  }
})

export const { setSelectedCategory, clearSelectedCategory } =
  insuranceCategorySlice.actions
export const { selectSelectedCategory } = insuranceCategorySlice.selectors
export default insuranceCategorySlice
